export const POINTER_TOGGLE_EVENT = 'ai-pointer:toggle';
export const POINTER_CLOSED_EVENT = 'ai-pointer:closed';
export const POINTER_HOVER_EVENT = 'ai-pointer:hover';
export const POINTER_BUTTON_ATTRIBUTE = 'data-ai-pointer-button';
export const POINTER_POPOVER_ATTRIBUTE = 'data-ai-pointer-popover';

import type { PointerHelpSource } from './types';

export type PointerAnchor = {
  help?: PointerHelpSource;
  align?: 'start' | 'end' | 'flush';
  isAutomatic?: boolean;
  x: number;
  y: number;
  originX: number;
  originY: number;
};

export type PointerHoverDetail = PointerAnchor & { hovering: boolean };
